import React, {Component} from 'react';
import styled from 'styled-components';
import CourtesyCarsPricingForm from './CourtesyCarsPricingForm';
import {connect} from 'react-redux';
import Loader from '../../../Loader';
import {FormattedDate, FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import get from 'get-value';
import courtesyCarsPricingMessages from "../../../../intl/admin/courtesyCarsPricingMessages";
import {fetchCourtesyCarsPricing, saveCourtesyCarsPricing} from "../../../../actions/admin/actionAdminCourtesyCarsPricing";

const Wrapper = styled.div`
  padding-top: 30px;
`;

const Header = styled.div`
  margin-top: 10px;
  font-style: italic;
`;

class CourtesyCarsPricingContainer extends Component {
    componentDidMount() {
        this.props.fetchCourtesyCarsPricing(this.props.domain, this.props.selectedGroup);
    }

    save = (values) => {
        const { countryGroup, ...levels } = values;
        const data = {
            ...levels,
            group: countryGroup || this.props.selectedGroup,
        };
        this.props.saveCourtesyCarsPricing(this.props.domain, data);
    };

    render() {
        const {isLoading, coutesyCarsPricing, selectedGroup} = this.props;
        const { group, ...levels } = coutesyCarsPricing;
        return (
            <Wrapper>
                <h5><FormattedMessage {...courtesyCarsPricingMessages.COURTESY_CARS_PRICING}/></h5>
                {isLoading && <Loader/>}
                {!isLoading &&
                <div>
                    <CourtesyCarsPricingForm onSubmit={this.save} initialValues={levels}
                                 form={`courtesyCarsPricingForm${selectedGroup}`}/>
                </div>}
            </Wrapper>
        );
    }
}

CourtesyCarsPricingContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    coutesyCarsPricing: PropTypes.object.isRequired,
    fetchCourtesyCarsPricing: PropTypes.func.isRequired,
    saveCourtesyCarsPricing: PropTypes.func.isRequired,
    domain: PropTypes.string.isRequired,
    selectedGroup: PropTypes.string.isRequired,
    profile: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.adminCourtesyCarsPricing.isLoading,
    coutesyCarsPricing: state.adminCourtesyCarsPricing.courtesyCarsPricing,
    profile: state.profile.userDetail,
});

export default connect(mapStateToProps, {
    fetchCourtesyCarsPricing,
    saveCourtesyCarsPricing,
})(CourtesyCarsPricingContainer);
